module.exports = __webpack_public_path__ + "static/media/lumi-fundo-de-tela-azul.9546403f.png";